import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  hsmConfigName: validationNotEmpty("HSM Config Name"),
  hsmPin: validationNotEmpty("HSM PIN"),
  hsmProvider: validationNotEmpty("HSM Provider"),
});